import { FontColorHotkey, FontColorOptions } from './options'

export * from './plugin/with-font-color'
export * from './plugin/font-color-editor'
export type { FontColorOptions, FontColorHotkey }
